export default __webpack_public_path__ + "static/news4-8b5671ee43a550b6c5a5cd07a981e3d9.jpg";